<template>
  <div class="page-title">
    <h2 class="headline text-center"><slot /></h2>
  </div>
</template>
<style lang="scss">
.page-title {
  .title {
    color: #363636;
    font-weight: 300;
  }
}
</style>
<script>
export default {
  name: 'PageTitle'
}
</script>
